import { render, staticRenderFns } from "./ClassroomDetailTabMessageTeacher.vue?vue&type=template&id=fda9c8f8&scoped=true"
import script from "./ClassroomDetailTabMessageTeacher.vue?vue&type=script&lang=js"
export * from "./ClassroomDetailTabMessageTeacher.vue?vue&type=script&lang=js"
import style0 from "./ClassroomDetailTabMessageTeacher.vue?vue&type=style&index=0&id=fda9c8f8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda9c8f8",
  null
  
)

export default component.exports